import React from "react";
import { Link } from "react-router-dom";

export default function BrandLogo({
  to = "/",
  variant = "default",
  className = "",
  showTagline = false,
  centered = false,
}) {
  const img = (
    <img
      src="/logo-demaxtore.png"
      alt="DeMaxtore"
      className={
        variant === "compact"
          ? "h-[2.925rem] w-auto object-contain"
          : variant === "hero"
            ? "h-[3.9rem] lg:h-[4.55rem] w-auto max-w-full object-contain"
            : "h-[3.25rem] w-auto object-contain"
      }
    />
  );

  const wrapClass = centered
    ? `flex flex-col items-center mx-auto w-full ${className}`
    : `inline-flex flex-col ${className}`;

  const content = (
    <span className={wrapClass}>
      {img}
      {showTagline && (
        <span className="mt-1 text-[11px] italic text-[hsl(var(--brand-navy))]/70 hidden sm:block">
          Connecting Buyers with Turkish Suppliers
        </span>
      )}
    </span>
  );

  if (to) {
    return (
      <Link
        to={to}
        className={`group transition-opacity hover:opacity-90 ${centered ? "flex justify-center w-full" : "inline-flex"}`}
      >
        {content}
      </Link>
    );
  }

  return <span className={centered ? "flex justify-center w-full" : "inline-flex"}>{content}</span>;
}
